import { useState } from 'react';
import Reveal from '@/components/feature/Reveal';
import { entryCards } from '@/mocks/home';

interface EntryCardProps {
  icon: string;
  title: string;
  desc: string;
  tag: string;
  value: string;
  index: number;
}

function EntryCard({ icon, title, desc, tag, value, index }: EntryCardProps) {
  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    try {
      await navigator.clipboard.writeText(value);
    } catch {
      // 剪贴板不可用时仍给出视觉反馈
    }
    setCopied(true);
    window.setTimeout(() => setCopied(false), 1800);
  };

  return (
    <Reveal delay={index * 90} className="h-full">
      <article className="flex h-full flex-col rounded-lg border border-background-200/80 bg-background-50 p-5">
        <div className="flex items-start justify-between">
          <span className="flex h-11 w-11 items-center justify-center rounded-md bg-primary-100 text-primary-700">
            <i className={`${icon} text-xl`} />
          </span>
          <span className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-[11px] font-medium text-secondary-900">
            {tag}
          </span>
        </div>

        <h3 className="mt-4 font-heading text-lg font-bold text-foreground-950">{title}</h3>
        <p className="mt-2 flex-1 text-sm leading-relaxed text-foreground-600">{desc}</p>

        <div className="mt-5 flex items-center gap-2">
          <a
            href="#entry"
            className="inline-flex flex-1 cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md bg-foreground-950 px-3 py-2 text-sm font-medium text-background-50 transition-colors hover:bg-foreground-800"
          >
            <i className="ri-arrow-right-up-line text-base" />
            前往
          </a>
          <button
            type="button"
            onClick={handleCopy}
            className="inline-flex cursor-pointer items-center justify-center gap-1.5 whitespace-nowrap rounded-md border border-background-300 px-3 py-2 text-sm text-foreground-700 transition-colors hover:bg-background-100"
          >
            <i className={copied ? 'ri-check-line text-base text-primary-600' : 'ri-file-copy-line text-base'} />
            {copied ? '已复制' : '复制'}
          </button>
        </div>
      </article>
    </Reveal>
  );
}

export default function EntryGateway() {
  return (
    <section id="entry" className="scroll-mt-28 bg-background-100">
      <div className="mx-auto max-w-7xl px-4 py-14 md:px-6 md:py-20">
        <Reveal>
          <header className="max-w-2xl">
            <p className="text-xs font-medium uppercase tracking-[0.3em] text-primary-600">
              ENTRY GATEWAY
            </p>
            <h2 className="mt-3 font-heading text-2xl font-bold text-foreground-950 md:text-4xl">
              四条通道，选一条先进来
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-base">
              入口、网址、地址与直达链接各司其职。主线路优先，备用线路兜底，复制后即可放进收藏夹。
            </p>
          </header>
        </Reveal>

        <div className="mt-10 grid grid-cols-1 gap-4 sm:grid-cols-2 lg:grid-cols-4">
          {entryCards.map((card, index) => (
            <EntryCard key={card.title} {...card} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
}